import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { formatCurrency } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from "../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class UrlPauService {

    public urlBase = environment.urlBase; 

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

   }

  getUrlPauService(idPedido: string, montoTotal: string, cantProductos:string, urlPau: string, validar:boolean, tienda_id:string, nombre_tienda:string){
   var list;
    if (validar) {
     list = {
      'accion':'urlACTIVA',
      'valores' :{
      'tienda:id': tienda_id
    }
    };    
   } else {
     list = {
      'accion':'pedidoCompletado',
      'valores' :{
        'tienda_id': tienda_id,
        'nombreComercio': nombre_tienda,
        'tipoTrasaccion': 'compra',
      'pedido': idPedido,
      'monto_total': montoTotal,
      'can_prod': cantProductos
    }
    };    
   }
    
    
   //console.log(JSON.stringify(list));

   const headers = new HttpHeaders ({
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization': 'Basic c2lsaWNlcG9zOm1ZUFJ2dVAw'
  });

  let params = 'json='+JSON.stringify(list)+'&url='+urlPau;
  //console.log('parametros url: ',params);

  return this.http.post(this.urlBase + 'admin/retornarPAU', params, {headers:headers});
  //return this.http.post("https://api-dom.smallshi.com/admin/retornarPAU", params, {headers:headers});
  }

  ObjecttoParams(obj) {
    var p = [];
      for (var key in obj) {
      p.push(key + '=' + encodeURIComponent(obj[key]));
      } 
      return p.join('&'); 
    }

    getUrlBanco(){
      const headers = new HttpHeaders ({
        'Content-Type': 'application/json'
      });
      
      //return this.http.get('/servicios/mejor_canal/index.php?token=N2IyMjY1Njk2NDIyM2EyMjM4MzUyMjJjMjI2OTY5NjQyMjNhMjIzMTMwMzAyMjJjMjI3MDcyNmYyMjNhMjIzMTMwMzMyMjJjMjI3MjY1NzA2MTcyNzQ2ZjIyM2EyMjZkNDEyMjJjMjI2ZTQ0MjIzYTMzMzAyYzIyNzQ2NTc4NzQ2ZjIyM2EyMjIyN2Q&formato=text ', {headers});
      return this.http.get('https://latam.pau.zone/servicios/mejor_canal/index.php?token=N2IyMjY1Njk2NDIyM2EyMjM4MzUyMjJjMjI2OTY5NjQyMjNhMjIzMTMwMzAyMjJjMjI3MDcyNmYyMjNhMjIzMTMwMzMyMjJjMjI3MjY1NzA2MTcyNzQ2ZjIyM2EyMjZkNDEyMjJjMjI2ZTQ0MjIzYTMzMzAyYzIyNzQ2NTc4NzQ2ZjIyM2EyMjIyN2Q&formato=text');
      //return this.http.get('https://back1-latam.pau.zone/servicios/mejor_canal/index.php?token=N2IyMjY1Njk2NDIyM2EyMjM4MzUyMjJjMjI2OTY5NjQyMjNhMjIzMTMwMzAyMjJjMjI3MDcyNmYyMjNhMjIzMTMwMzMyMjJjMjI3MjY1NzA2MTcyNzQ2ZjIyM2EyMjZkNDEyMjJjMjI2ZTQ0MjIzYTMzMzAyYzIyNzQ2NTc4NzQ2ZjIyM2EyMjIyN2Q&formato=text');
    }
    getSantizeUrl(url : string) { 
      return this.sanitizer.bypassSecurityTrustUrl(url); 
  }
}
